import { environment } from 'src/environments/environment'
import { UserAccessRightService } from 'src/app/shared/services/user-access-rights.service'
import { Observable, of } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'
import { configurationOptionSelectors } from '../../configuration-option.selectors'
import { NotificationService } from 'src/app/core/notification.service'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import {
  catchError,
  distinctUntilChanged,
  map,
  take,
  timeout
} from 'rxjs/operators'
import { ConfigurationOptionService } from '../../configuration-option.service'
import { Actions, ofType } from '@ngrx/effects'
import { configurationOptionActions } from '../../configuration-option.actions'
@Component({
  selector: 'configuration-option-contact-us',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionContactUsCardComponent implements OnInit {
  @Output() onSubmit = new EventEmitter<any>()
  public formValues$: Observable<any>
  public form: UntypedFormGroup
  public isLoading$: Observable<boolean>
  @Input() isCollapsed: any = false
  //public isCollapsed = false
  public accessRights = AccessRights
  public availableLanguages = environment.frontendLanguages.reduce(
    (acc, curr) => {
      if (curr != 'xx') return (acc[curr] = true), acc
      else return acc
    },
    {}
  )

  constructor(
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private notificationService: NotificationService,
    public accessRightService: UserAccessRightService,
    private configOptionService: ConfigurationOptionService,
    private actions$: Actions
  ) {}
  config: any = {
    placeholder: '',
    tabsize: 2,
    height: '200px',
    dialogsInBody: true,
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      [
        'font',
        [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'clear'
        ]
      ],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']]
    ],
    fontNames: [
      'Helvetica',
      'Arial',
      'Arial Black',
      'Comic Sans MS',
      'Courier New',
      'Roboto',
      'Times',
      'opensans',
      'sansserif',
      'monospace',
      'serif'
    ]
  }
  ngOnInit() {
    this.form = this.fb.group({
      nl_contact_me_page_html: [null, []],
      en_contact_me_page_html: [null, []],
      fr_contact_me_page_html: [null, []],
      de_contact_me_page_html: [null, []]
    })
    this.formValues$ = this.store
      .select(configurationOptionSelectors.selectAll)
      .pipe(
        distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b)),
        map((configOptions) =>
          this.configOptionService.mapEntitiesToObject(configOptions)
        )
      )
    this.isLoading$ = this.store.select(
      configurationOptionSelectors.selectIsLoading
    )
  }

  public onFormSubmit(): void {
    if (!this.form.valid) {
      return
    }
    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(4000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )

    this.configOptionService.updateOrCreateMany(this.form.value)
  }
}
